import React, { lazy } from 'react';
import { Route, Switch } from 'react-router-dom';
import routes from '../../constants/routes';
import LazyLoader from '../components/LazyLoader/LazyLoader';
import { RouteInterface } from './types';

const ROUTES: RouteInterface[] = [
  {
    path: routes.INDEX,
    component: lazy(() => import('../pages/Login/Login')),
    exact: true,
  },

  {
    path: routes.FORGOT_PASSWORD,
    component: lazy(() => import('../pages/ForgotPassword/ForgotPassword')),
    exact: true,
  },
  {
    path: routes.RESET_PASSWORD,
    component: lazy(() => import('../pages/ResetPassword/ResetPassword')),
    exact: true,
  },
  {
    path: routes.ERROR_PAGE,
    component: lazy(() => import('../pages/ErrorPage/ErrorPage')),
    exact: true,
  },
];

const PublicRoutes: React.FC = () => (
  <Switch>
    {ROUTES.map(
      (route: RouteInterface) => (
        // route.redirect ? (
        //   <Redirect key={route.path} from={route.path} to={route.to} />
        // ) : (
        <Route
          key={route.path}
          path={route.path}
          exact={route.exact}
          component={LazyLoader(route.component)}
        />
      ),
      // ),
    )}
  </Switch>
);

export default PublicRoutes;
